<template>
  <div class="dashboard">
    <div style="width:1140px">

      <div id="transcoding" class="dashboard-container">

        <div class="dashboard-toplayout">
          <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
          <span class="dashboard-toplayout-ftsbig">资源转码</span>

        </div>

        <!-- <el-table :data="fileList" :row-style="rowStyle" style="width: 100%;margin: 20px 0px;" empty-text='请上传资源' :header-cell-style="{fontSize: '12px',color:'#7B84A1',padding:'0px',textAlign:'center',opacity: '0.5'}">

        <el-table-column label="文件" prop="webkitRelativePath" align="center"></el-table-column>
        <el-table-column label="类型" prop="type" align="center"></el-table-column>

        <el-table-column label="转码说明" prop="progress" align="center">

          <template slot-scope="scope">

            <el-progress :percentage="scope.row.progress" :status="customColorMethod(scope.row)"></el-progress>

          </template>

        </el-table-column>

        <el-table-column label="转码结果" align="center">
          <template slot-scope="scope">

            <img src="@/assets/success.png" alt="404">
            <i class="el-icon-loading"></i>
          </template>
        </el-table-column>
      </el-table> -->
        <el-table :data="fileList" style="width: 100%;margin: 20px 0px;" empty-text="请上传资源" :header-cell-style="{fontSize: '12px',color:'#7B84A1',padding:'0px',textAlign:'center',opacity: '0.5'}">

          <el-table-column label="文件" prop="name" width="360" align="left">
            <template slot-scope="scope">
              <div class="row">

                <img v-if="scope.row.resourceType=='image'" src="@/assets/img.png" alt="404">
                <img v-if="scope.row.resourceType=='pdf'" src="@/assets/pdf.png" alt="404">
                <img v-if="scope.row.resourceType=='video'" src="@/assets/video.png" alt="404">
                <img v-if="scope.row.resourceType=='audio'" src="@/assets/rec.png" alt="404">
                <img v-if="scope.row.resourceType=='zip'" src="@/assets/zip.png" alt="404">

                <span style="margin-left:8px">{{ scope.row.resourceName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="type" width="80px" align="center">

            <template slot-scope="scope">

              <span v-if="scope.row.resourceType=='image'">图片</span>

              <span v-else-if="scope.row.resourceType=='pdf'">PDF</span>
              <span v-else-if="scope.row.resourceType=='video'">视频</span>
              <span v-else-if="scope.row.resourceType=='audio'">音频</span>
              <span v-else-if="scope.row.resourceType=='zip'">压缩包</span>

            </template>
          </el-table-column>

          <el-table-column label="转码说明" align="center">

            <template slot-scope="scope">
              <span v-if="scope.row.resourceType!='image'&&scope.row.resourceType!='video'&&scope.row.resourceType!='audio'">该格式不转码</span>

              <span v-if="scope.row.status==1" style="color:#FA5E5F;font-size:12px"> 资源包含违规内容，已删除 </span>
            </template>

          </el-table-column>

          <el-table-column label="转码结果" width="100px" align="center">
            <template slot-scope="scope">
              <img v-if="scope.row.resourceType!='image'&&scope.row.resourceType!='video'&&scope.row.resourceType!='audio'" src="@/assets/success.png" alt="404">

              <img v-else-if="scope.row.status==1" src="@/assets/interrupt.png" alt="404">
              <img v-else-if="scope.row.status==2" src="@/assets/success.png" alt="404">
              <i v-else class="el-icon-loading" />
            <!-- <img v-else src="@/assets/zip.png" alt="404"> -->

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dashboard-container">

        <div class="dashboard-toplayout">

          <span class="dashboard-toplayout-ftsbig">温馨提示</span>

        </div>

        <ol class="dashboard-toplayout-ftsnomal">
          <li>
            根据文件数量/格式/大小不同，转码用时不同，转码完成后将自动进行下一步操作。

          </li>
          <li>转码用时约需5-100秒，如转码时间过长可点击“在后台转码”进入著录步骤，系统将在后台完成转码工作。（该操作可能影响著录步骤AI识别和内容预览）。</li>
        </ol>

      </div>
      <div id="next" class="dashboard-container" style="padding:0px;margin-bottom:20px">
        <el-button type="primary" style="width:100%;font-size: 14px;color: #FFFFFF;height: 40px;background: #7B84A1;opacity: 0.5;border:0px" size="default">自动执行中，完成后将自动进入下一步</el-button>

      </div>
      <div class="dashboard-container" style="padding:0px;margin-bottom:20px">
        <el-button type="primary" style="width:100%;background-color:#4C70E8;font-size: 14px;font-weight:bold;border-radius: 5px;" size="default" @click="uploadnext">在后台转码·著录</el-button>
      </div>

    </div>
    <div>
      <div class="rowright">

        <div class="rowright-contain" style="height: 70px;" @click="scrollViewId('#transcoding')">
          <img style="width:36px;height: 36px;" src="@/assets/implement.png" alt="404">
          <span class="rowright-btn">自动执行中</span>

        </div>
        <div class="rowright-contain" style="margin-top:5px;height:54px;background-color:#4C70E8;" @click="scrollViewId('#next')">
          <!-- <a class="rowright-btn" @click="scrollViewId('#next')" style="background-color:#4C70E8;margin-top:5px;height: 54px;padding: 10px;"> -->

          <p class="rowright-next"> 后台转码</p>

          <span class="rowright-btnfill" style="margin-top:4px;margin-left:30px;">著录</span>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import {
  aiTask,
  standardTranscoding,
  collectionResourceRecord
} from '@/api/library'

export default {

  props: {
    nextStatus: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      fileList: [],
      time: null
    }
  },
  mounted() {
    this.standardTranscoding()
  },
  beforeDestroy() {
    if (this.time != null) {
      clearInterval(this.time)
      this.time = null
    }
  },
  methods: {
    async standardTranscoding() {
      const res = await standardTranscoding({
        ids: this.$route.query.collectionId,
        tenantId: this.$store.getters.tenantId
      })
      if (res.data) {
        this.collectionResourceRecord()
      }
    },
    changeData() {
      this.$router.push({
        path: '/single',
        query: {
          collectionId: 0,
          status: 'upload'
        }
      })
      this.uploadnext()
    },
    async collectionResourceRecord() {
      const res = await collectionResourceRecord({
        ids: this.$route.query.collectionId
      })

      if (res.data != null && res.data.length > 0) {
        this.fileList = res.data[0].aiTaskResourceVOS
        this.timeSend()
      }
    },
    timeSend() {
      this.time = setInterval(() => {
        this.aiTask()
      }, 10000)
    },
    async aiTask() {
      const res = await aiTask({
        ids: this.$route.query.collectionId,
        type: 'transcoding'
      })

      if (res.data != null) {
        if (res.data.length === 0) {
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }

          return
        }

        this.fileList.forEach(element => {
          const itemIndex = res.data[0].aiTaskResourceVOS.find(item => {
            return element.resourceId === item.resourceId
          })
          if (itemIndex) {
            element.status = itemIndex.status
          } else {
            element.status = 1
          }
        })

        if (res.data[0].status === 2) {
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          this.uploadnext()
        }
      }
    },
    uploadnext() {
      this.$emit('uploadNext')
    },
    rowStyle({
      row,
      index
    }) {
      const styleJson = {
        'backgroundColor': '#fff',
        'border-bottom': '1px solid #EBEEF5',
        'border-top': '1px solid #EBEEF5'
      }
      return styleJson
    },
    scrollViewId(name) {
      document.querySelector(name).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .is-leaf {
  border-bottom: 1px solid #EBEEF5;
  border-top: 1px solid #EBEEF5;
}

::v-deep .el-table__empty-text {
  line-height: 100px;
  width: 50%;
  color: #7B84A1;
  font-size: 12px;
  opacity: 0.5;
}

::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

.row {

  display: flex;
  align-items: center;
  float: right;
  width: 315px;
  overflow: hidden;
  text-align: center;
  margin-right: 0px;

  &-img {
    opacity: 0.5;
  }

  &-img:hover {
    opacity: 1;
  }
}

.el-table {
  ::v-deep tbody tr:hover>td {
    background-color: transparent;
  }

  ::v-deep th {
    padding: 3px 0;
    min-width: 0;
  }

  ::v-deep td {
    border-bottom: 0px;
    color: #1F233E;
    font-size: 12px;
    padding: 3px 0;
    min-width: 0;
  }
}

.rowright {
  display: flex;
  position: fixed;
  top: 200px;
  width: 100px;
  flex-direction: column;

  &-contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 30px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #b7bccd;
    cursor: pointer;
  }

  &-btnfill {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;

  }

  &-btn {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;
    width: auto;

  }

  &-next {

    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #FEFEFE;
  }
}

.dashboard {
  margin: auto;
  padding-top: 51px;
  width: 1240px;
  flex-direction: row;
  display: flex;
  box-sizing: border-box;

  &-container {

    padding: 20px;
    border-radius: 5px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  &-toplayout {
    display: flex;
    // flex-direction: row-reverse;
    margin: 0px 0px 10px 0px;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 25px;

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-space {
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 11px;
      justify-content: space-between;
    }

    &-mgright {
      margin-right: 11px;

      font-size: 12px;
      line-height: 24px;
      color: #1F233E;

    }

    &-num {
      width: 24px;
      height: 24px;
      font-size: 12px;
      margin-right: 11px;
      // line-height: 24px;
      color: #ffff;
      display: flex;
      justify-content: center;
      background: #7B84A1;
      border-radius: 5px;
    }

    &-btn {
      margin-right: 15px;
      height: 24px;
      width: 176px;
      background: #7B84A1;
      border-radius: 5px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 24px;
    }

    &-ftsbig {

      font-size: 20px;
      font-weight: bold;
      color: #4C70E8;

    }

    &-ftsnomal {
      /* margin-left: -25px; */
      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }
  }
}
</style>
